export const jsonBlockRootSx = {
  my: '8px',
  border: 'none',
  borderRadius: 'var(--app-radius-md)',
  overflow: 'hidden',
}

export const jsonBlockHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bgcolor: 'background.default',
  p: '6px 10px',
  cursor: 'pointer',
  '&:hover': { bgcolor: 'action.hover' },
}

export const jsonBlockHeaderLeadingSx = { display: 'flex', alignItems: 'center', gap: '6px' }

export const jsonBlockTitleSx = { fontWeight: 600, color: 'text.secondary' }

export const jsonBlockCopyButtonSx = { width: 24, height: 24 }

export const jsonBlockBodySx = { p: '10px', bgcolor: 'background.paper', overflowX: 'auto' }

export const jsonBlockPreSx = { margin: 0, fontFamily: 'monospace', color: 'text.primary' }
